<div class="footer">
  <div class="descricao"><strong>Secretaria de Planejamento, Governança e Gestão</strong> &copy; {{ data | date:'yyyy'}}</div>
  <div><img src="assets/images/logo_procergs.gif" alt="logo_procergs"></div>
</div>